import React, { Suspense, lazy } from 'react';

import Header from './components/Header';
import Footer from './components/Footer';
import BackTopBtn from './components/BackTopBtn';
import Home from './pages/Home';
import { Route, Routes, useLocation } from 'react-router-dom';

const AccountDeletionPolicy = lazy(() => import('./components/DeleteAccount'));
const Skills = lazy(() => import('./components/Skills'));
const RestaurantPage = lazy(() => import('./components/RestaurantPage'));
const Services = lazy(() => import('./components/Services'));
const Testimonials = lazy(() => import('./components/Testimonials'));
const QuieroSerDriver = lazy(() => import('./components/QuieroSerDriver'));
const ContactPage = lazy(() => import('./components/ContactPage'));
const TiendaPage = lazy(() => import('./components/TiendaPage'));
const OpenAppPage = lazy(() => import('./components/OpenAppPage'));
const AppDeepLinkRedirect = lazy(() => import('./components/AppDeepLinkRedirect'));

const RouteFallback = () => (
  <div className='min-h-[40vh] flex items-center justify-center text-paragraph'>
    Cargando...
  </div>
);

const STATIC_PATHS = new Set([
  '/',
  '/corporativo',
  '/restaurantes',
  '/politicas',
  '/afiliate',
  '/quiero-ser-driver',
  '/contacto',
  '/eliminacion-cuenta',
  '/app',
  '/viaje',
  '/paqueteria',
]);

const isStaticOrInfoPath = (pathname) => {
  if (STATIC_PATHS.has(pathname)) return true;
  if (pathname.startsWith('/info/')) return true;
  if (pathname.startsWith('/tienda/')) return true;
  if (pathname.startsWith('/producto/')) return true;
  return false;
};

const App = () => {
  const location = useLocation();
  const isTiendaPage =
    location.pathname.startsWith('/tienda/') ||
    (!isStaticOrInfoPath(location.pathname) && location.pathname !== '/');

  const isOpenAppPage =
    location.pathname === '/app' ||
    location.pathname.startsWith('/producto/') ||
    location.pathname === '/viaje' ||
    location.pathname === '/paqueteria';

  const showChrome = !isTiendaPage && !isOpenAppPage;

  return (
    <div className={`${showChrome ? 'bg-wash' : 'bg-primary'} min-h-screen overflow-x-hidden`}>
      {showChrome && <Header />}

      <main className='relative'>
        <Suspense fallback={<RouteFallback />}>
          <Routes>
            <Route path='/' element={<Home />} />
            <Route path='/restaurantes' element={<RestaurantPage />} />
            <Route path='/corporativo' element={<Skills />} />
            <Route path='/politicas' element={<Testimonials />} />
            <Route path='/info/afiliate' element={<Services />} />
            <Route path='/info/quiero-ser-driver' element={<QuieroSerDriver />} />
            <Route path='/info/contacto' element={<ContactPage />} />
            <Route path='/afiliate' element={<Services />} />
            <Route path='/quiero-ser-driver' element={<QuieroSerDriver />} />
            <Route path='/contacto' element={<ContactPage />} />
            <Route path='/eliminacion-cuenta' element={<AccountDeletionPolicy />} />

            <Route path='/app' element={<OpenAppPage mode='app' />} />
            <Route path='/viaje' element={<AppDeepLinkRedirect tab='viajes' />} />
            <Route path='/paqueteria' element={<AppDeepLinkRedirect tab='paqueteria' />} />
            <Route path='/producto/:productId' element={<OpenAppPage mode='producto' />} />

            <Route path='/tienda/:ruta' element={<TiendaPage />} />
            <Route path='/:ruta' element={<TiendaPage />} />
          </Routes>
        </Suspense>
      </main>

      {showChrome && <Footer />}
      {showChrome && <BackTopBtn />}
    </div>
  );
};

export default App;
